const c = (r) => typeof r == "object" && r !== null, f = (r) => typeof r == "number", y = (r) => Array.isArray(r) ? r.length === 0 : c(r) ? Object.keys(r).length === 0 : typeof r == "string" ? r.trim().length === 0 : !1;
function g(r, n, t) {
  n === void 0 && (n = r, r = 0), t === void 0 && (t = r < n ? 1 : -1);
  const i = Math.max(Math.ceil((n - r) / t), 0), o = Array(i);
  for (let e = 0; e < i; e++, r += t)
    o[e] = r;
  return o;
}
const h = (r) => {
  try {
    return !!new URL(r);
  } catch (n) {
    return !1;
  }
};
export {
  y as isEmpty,
  f as isNumber,
  c as isObject,
  h as isValidUrl,
  g as range
};
//# sourceMappingURL=validations.es.js.map
